import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  MarketingContact,
  UpdateContactConsentPayload
} from "../../marketing.types";
import { requestUpdateContactConsent } from "./updateContactConsent.request";

const useUpdateContactConsent = (
  options?: MutationOptions<
    MarketingContact,
    ApiServiceError<ApiError>,
    UpdateContactConsentPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateContactConsent,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "contacts"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateContactConsent;
